/**
 * Created by dbslab on 12/06/17.
 */
export default {
  install: function (Vue,) {

    Vue.prototype.$toDashedString = function (string) {
      return string.toLowerCase().replace('&', '').replace(/ /g, '-').replace(/[-]+/g, '-').replace(/[^\w-]+/g, '')
    }

    // TODO: rename file to 'helpers'
    Vue.prototype.$debounce = function (func, wait = 150, immediate = false) {
      var timeout;
      return function () {
        var context = this, args = arguments;
        var later = function () {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    }

    Vue.prototype.$isset = function (value) {
      return typeof value !== "undefined"
    }

    Vue.prototype.$cleanObject = function (object) {
      for (var field in object) {
        if (object[field] === null || object[field] === undefined || object[field] === "") {
          delete object[field];
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/plugins/stringHelper.js